import { ROUTES } from '@/constants/routes';
import { IMenuItemType } from '@/ui';
import { TFunction } from 'i18next';
import { NavLink } from 'react-router-dom';

export enum MenuKeys {
  WEBSITE_MANAGEMENT = '/website-management',
  FAQ = '/faq-group',
}

export const getMenuConfig = (t: TFunction, isChannelShowCase?: boolean): IMenuItemType[] => [
  {
    key: MenuKeys.WEBSITE_MANAGEMENT,
    label: <span>{t('menu_website_management')}</span>,
    children: [
      {
        key: ROUTES.GENERAL_SETTINGS,
        label: (
          <NavLink to={ROUTES.GENERAL_SETTINGS} end>
            {t('menu_general_settings')}
          </NavLink>
        ),
      },
      {
        key: ROUTES.UI_SETTINGS,
        label: (
          <NavLink to={ROUTES.UI_SETTINGS} end>
            {t('menu_ui')}
          </NavLink>
        ),
      },
      {
        key: ROUTES.SHIPPING_PRICES,
        label: (
          <NavLink to={ROUTES.SHIPPING_PRICES} end>
            {t('menu_shipping_prices')}
          </NavLink>
        ),
      },
      {
        key: ROUTES.DELIVERY_SETTINGS,
        label: (
          <NavLink to={ROUTES.DELIVERY_SETTINGS} end>
            {t('menu_delivery_settings')}
          </NavLink>
        ),
      },
      {
        key: ROUTES.PAYMENT_METHODS,
        label: (
          <NavLink to={ROUTES.PAYMENT_METHODS} end>
            {t('menu_payment_methods')}
          </NavLink>
        ),
      },
    ],
  },
  {
    key: ROUTES.PAGES_MANAGEMENT,
    label: <NavLink to={ROUTES.PAGES_MANAGEMENT}>{t('menu_pages_management')}</NavLink>,
  },
  {
    key: ROUTES.PUSH_ORDERS,
    label: <NavLink to={ROUTES.PUSH_ORDERS}>{t('menu_push_orders')}</NavLink>,
  },
  {
    key: ROUTES.COUPONS,
    label: <NavLink to={ROUTES.COUPONS}>{t('menu_coupons')}</NavLink>,
  },
  {
    key: ROUTES.REVIEWS,
    label: <NavLink to={ROUTES.REVIEWS}>{t('menu_reviews')}</NavLink>,
  },
  {
    key: ROUTES.CHANNELS,
    label: <NavLink to={ROUTES.CHANNELS}>{t('menu_channels')}</NavLink>,
  },
  {
    key: ROUTES.BRANDS,
    label: <NavLink to={ROUTES.BRANDS}>{t('menu_brands')}</NavLink>,
  },
  {
    key: ROUTES.SEO,
    label: <span>{t('menu_seo')}</span>,
    children: [
      {
        key: ROUTES.REDIRECTS,
        label: (
          <NavLink to={ROUTES.REDIRECTS} end>
            {t('menu_redirects')}
          </NavLink>
        ),
      },
      {
        key: ROUTES.METATAGS_TEMPLATES,
        label: (
          <NavLink to={ROUTES.METATAGS_TEMPLATES} end>
            {t('menu_metatags_templates')}
          </NavLink>
        ),
      },
      {
        key: ROUTES.LINKING_TOOL,
        label: (
          <NavLink to={ROUTES.LINKING_TOOL} end>
            {t('menu_linking_tool')}
          </NavLink>
        ),
      },
      {
        key: ROUTES.ROBOTS_TXT,
        label: (
          <NavLink to={ROUTES.ROBOTS_TXT} end>
            {t('menu_robots_txt')}
          </NavLink>
        ),
      },
      {
        key: ROUTES.SITE_MAP,
        label: (
          <NavLink to={ROUTES.SITE_MAP} end>
            {t('menu_site_map')}
          </NavLink>
        ),
      },
      {
        key: ROUTES.MERCHANT_SETTINGS,
        label: (
          <NavLink to={ROUTES.MERCHANT_SETTINGS} end>
            {t('menu_merchant_settings')}
          </NavLink>
        ),
      },
      {
        key: ROUTES.LLM_CONFIG,
        label: (
          <NavLink to={ROUTES.LLM_CONFIG} end>
            {t('menu_llm_config')}
          </NavLink>
        ),
      },
      {
        key: ROUTES.LLM_CHANNEL_TEMPLATE,
        label: (
          <NavLink to={ROUTES.LLM_CHANNEL_TEMPLATE} end>
            {t('menu_llm_channel_template')}
          </NavLink>
        ),
      },
    ],
  },
  {
    key: ROUTES.AKENEO,
    label: <span>{t('menu_akeneo')}</span>,
    children: [
      {
        key: ROUTES.AKENEO_PRODUCTS,
        label: (
          <NavLink to={ROUTES.AKENEO_PRODUCTS} end>
            {t('menu_akeneo_products')}
          </NavLink>
        ),
      },
      {
        key: ROUTES.CLEAN_UP_DATABASE,
        label: (
          <NavLink to={ROUTES.CLEAN_UP_DATABASE} end>
            {t('menu_akeneo_clean_up')}
          </NavLink>
        ),
      },
      {
        key: ROUTES.PRODUCTS_SYNC,
        label: (
          <NavLink to={ROUTES.PRODUCTS_SYNC} end>
            {t('menu_akeneo_products_sync')}
          </NavLink>
        ),
      },
    ],
  },
  {
    key: ROUTES.AI_BOT_CONFIGURATION,
    label: <NavLink to={ROUTES.AI_BOT_CONFIGURATION}>{t('menu_ai_bot_configuration')}</NavLink>,
  },
  {
    key: MenuKeys.FAQ,
    label: <span>{t('menu_faqs')}</span>,
    children: [
      {
        key: ROUTES.GENERAL_FAQS,
        label: (
          <NavLink to={ROUTES.GENERAL_FAQS} end>
            {t('menu_general_faq')}
          </NavLink>
        ),
      },
      {
        key: ROUTES.FAQS,
        label: (
          <NavLink to={ROUTES.FAQS} end>
            {t('menu_channel_faq')}
          </NavLink>
        ),
      },
      {
        key: ROUTES.SUGGESTED_FAQS,
        label: (
          <NavLink to={ROUTES.SUGGESTED_FAQS} end>
            {t('menu_suggested_faq')}
          </NavLink>
        ),
      },
    ],
  },
  {
    key: ROUTES.CONVERSATIONS,
    label: <NavLink to={ROUTES.CONVERSATIONS}>{t('menu_conversations')}</NavLink>,
  },
  {
    key: ROUTES.CATEGORIES,
    label: <NavLink to={ROUTES.CATEGORIES}>{t('menu_categories')}</NavLink>,
  },
  {
    key: ROUTES.VARIABLES,
    label: <NavLink to={ROUTES.VARIABLES}>{t('menu_variables')}</NavLink>,
  },
  {
    key: ROUTES.BLOG,
    label: <NavLink to={ROUTES.BLOG}>{t('menu_blog')}</NavLink>,
  },
  ...(isChannelShowCase
    ? [
        {
          key: ROUTES.WEBSITES,
          label: <NavLink to={ROUTES.WEBSITES}>{t('menu_websites')}</NavLink>,
        },
      ]
    : []),
  {
    key: ROUTES.LLM_TEMPLATES,
    label: <NavLink to={ROUTES.LLM_TEMPLATES}>{t('menu_llm_templates')}</NavLink>,
  },
];
